import React from "react";
import {Typography} from "@mui/material";
import DefaultLayoutNoSideBar from "../../layout/defaultLayoutNoSideBar";
import {getUserDetailsFromToken} from "../../utils/functions/userTokenDetails";
import {getUserToken} from "../../utils/functions/userToken";
import {ROUTES} from "../../utils/router";
import {useNavigate} from "react-router-dom";

const TransitionPageAdmin = () => {
    const navigate = useNavigate();
    const { UserDetails } = getUserDetailsFromToken(getUserToken());

    if (!UserDetails.isAdminUser && !UserDetails.isSuperAdminUser) {
        navigate(ROUTES.TRANSITION);
    }

    return (
        <DefaultLayoutNoSideBar>
            <Typography sx={{ mt: 4, textAlign: "center" }}>
                Please select an account.
            </Typography>
        </DefaultLayoutNoSideBar>
    );
};

export default TransitionPageAdmin;
